// @ts-nocheck
/* eslint-disable */

'use client';

import {
    Button,
    Flex,
    Heading,
    Icon,
    Tooltip,
} from 'politicamente-informados-ds';
import { StyledHeader, StyledNav } from './Header.theme';

import Link from 'next/link';
import Logo from '../Logo/Logo';
import React from 'react';
import { useGlobalContext } from '@/lib/globalContext';
import useMediaQuery from '@/lib/helpers/useMediaQuery';
import MobileMenu from '../MovileMenu/MobileMenu';
import { usePathname } from 'next/navigation';
import MaletaButton from '../MaletaButton/MaletaButton';

const Header = () => {
    const state = useGlobalContext();
    const isMobile = useMediaQuery('(max-width: 940px)');
    const thePathname = usePathname();
    const paths = thePathname;
    const pathNames = paths.split('/').filter((path) => path);
    const firstPath = pathNames[0];

    return (
        <>
            <StyledHeader id="masthead">
                <Logo />
                {!isMobile && (
                    <StyledNav>
                        <ul>
                            {state?.menus &&
                                state?.menus[`primary-menu`]?.map((item) => {
                                    return (
                                        <li
                                            key={`nav_menu_li_${item.id}`}
                                            className={
                                                firstPath ===
                                                item.url.replaceAll('/', '')
                                                    ? 'active'
                                                    : ''
                                            }>
                                            <Link
                                                href={item.url}
                                                target={item.target}
                                                prefetch={false}
                                                // onClick={() => headerOnClick(false, false)}
                                            >
                                                <Heading
                                                    size="captions"
                                                    className="fw-semibold">
                                                    {item.title}
                                                </Heading>
                                            </Link>
                                        </li>
                                    );
                                })}

                            <MaletaButton mainMenu={true} />
                        </ul>
                    </StyledNav>
                )}
                {!isMobile && (
                    <Button variant="primary" outlined={false}>
                        <Link href="/alinha-te">
                            <Heading size="captions" className="fw-semibold">
                                Alinha-te já 🗳️
                            </Heading>
                        </Link>
                    </Button>
                )}
                {isMobile && <MobileMenu menus={state?.menus}></MobileMenu>}
            </StyledHeader>
        </>
    );
};

export default Header;
